var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopifyProductsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0f99b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34256,
    stopColor: "#9fc85d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#7cb342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558b2f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.1005,33.5757l-18.48678,10.67346,6.79386,3.92232c.36644.21156.8179.21156,1.18434,0l16.11838-9.30558c.7896-.45586.78961-1.59554.00002-2.0514l-5.60981-3.23881Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.42148,41.8288l18.4871-10.67333-6.3164-3.64674c-.36645-.21157-.81792-.21156-1.18437,0l-16.11822,9.30586c-.78959.45587-.78958,1.59554.00001,2.0514l5.13187,2.96282Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.32819,51.8119l-6.87174-3.96749v9.87964l-4.19211-2.17681v-10.1232l-5.12063-2.95643c-.76735-.44303-1.72654.11075-1.72654.99681v18.68835c0,.41122.21938.7912.57551.99681l16.18448,9.34412c.76735.44303,1.72653-.11076,1.72653-.99681v-18.68818c0-.41122-.21938-.7912-.5755-.99681Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.12829,48.95472l1.34444,24.35743,14.8166-2.77598-2.10804-17.39545-2.34933-.69979c-.28103-1.33116-1.45859-5.87396-4.63637-7.06421-1.16854-.43782-1.93817-.11925-2.37785.22462-.10175.07964-.19369.17262-.28187.27025-1.03831-.37773-1.72727-.09317-2.12294.21693-.81453.63755-1.1256,1.95189-1.22618,3.1815l-1.05846-.31529ZM63.95307,46.83231c-.38362.92431-.51722,2.08364-.54403,3.09965l-1.14751-.34181c.06871-1.13996.30177-2.232.82531-2.64154.08548-.06715.3271-.25408.86623-.1163ZM67.26514,51.08061l-2.76667-.82413c.01117-1.05223.1315-2.15456.43248-2.936,1.20603.87231,1.93724,2.52401,2.33419,3.76013ZM70.6222,52.08054l-2.10594-.62725c-.36582-1.37194-1.23113-3.78787-2.96752-5.03424.16056-.11238.52859-.29412,1.26377-.01897,2.29718.8604,3.3971,4.08577,3.80968,5.68046Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "54.4467 50.24902 56.7922 50.24902 58.00784 48.61144 59.38281 73.52231 51.45414 71.66207 54.4467 50.24902"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopifyProductsScraper);
export default __webpack_public_path__ + "static/media/shopify-products-scraper.b03d2c124f9a65ce0ae843cbfd102296.svg";
export { ForwardRef as ReactComponent };